import {IApiBehavior} from './i-api-behavior';
import {AApiExecuterAsync} from "@/classes/core/api/a-api-executer-async";

export default class ApiExecuterAsync extends AApiExecuterAsync {
    constructor(behavior: IApiBehavior) {
        super(behavior)
    }
}
